import React from 'react';

import classNames from 'classnames';

interface TextFieldProps
  extends Omit<React.TextareaHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>, 'size'> {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  placeholder?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  className?: string;
  inputClassName?: string;
  type?: 'text' | 'password' | 'email';
  name?: string;
  isTextArea?: boolean;
}

export const TextField = ({
  placeholder = 'Enter text...',
  value,
  onChange,
  startIcon,
  endIcon,
  className,
  inputClassName,
  type = 'text',
  name,
  isTextArea,
  ...rest
}: TextFieldProps) => {
  const inputClass = classNames(
    'w-full bg-transparent bg-white p-2 rounded-lg font-semibold border-2 border-primary-20 focus:border-primary-30',
    {
      'pl-12': startIcon,
      'pr-10': endIcon,
      'pl-3': !startIcon,
      'pr-3': !endIcon,
    },
    inputClassName,
  );

  if (isTextArea) {
    return (
      <div
        className={classNames(
          'relative flex items-center w-[551px] rounded-lg bg-white',
          className,
        )}
        style={{ width: '-webkit-fill-available' }}
      >
        <textarea
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={inputClass}
          {...rest}
        />
      </div>
    );
  }

  return (
    <div
      className={classNames('relative flex items-center w-[551px] rounded-lg bg-white', className)}
      style={{ width: '-webkit-fill-available' }}
    >
      {startIcon && <span className="absolute left-3 top-2 h-[20px] w-[20px]">{startIcon}</span>}
      <input
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={inputClass}
        {...rest}
      />
      {endIcon && <span className="absolute right-3 top-2 h-[20px]">{endIcon}</span>}
    </div>
  );
};
